module.exports = __webpack_public_path__ + "static/statistics-3a62c6948c1f9e8e6b2dca0b3fcc9733.svg";